import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const ITMOMetadataPanel = ({ selectedCredits, onBulkAction }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');

  const countryOptions = [
    { value: '', label: 'All Countries' },
    { value: 'brazil', label: 'Brazil' },
    { value: 'colombia', label: 'Colombia' },
    { value: 'peru', label: 'Peru' },
    { value: 'chile', label: 'Chile' },
    { value: 'costa_rica', label: 'Costa Rica' }
  ];

  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'authorized', label: 'Authorized' },
    { value: 'pending', label: 'Pending Authorization' },
    { value: 'rejected', label: 'Authorization Rejected' },
    { value: 'ca_required', label: 'CA Required' }
  ];

  const handleBulkAuthorization = () => {
    onBulkAction('request_authorization', selectedCredits);
  };

  const handleBulkCAUpdate = () => {
    onBulkAction('update_ca_status', selectedCredits);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Globe" size={20} className="text-primary" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-card-foreground">ITMO Metadata Processing</h2>
            <p className="text-sm text-muted-foreground">Host-country authorization and corresponding adjustment tracking</p>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="px-3 py-1 bg-success/10 rounded-full">
            <span className="text-xs font-medium text-success">Real-time Sync Active</span>
          </div>
        </div>
      </div>
      {/* Search and Filters */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <Input
          type="search"
          placeholder="Search by serial number..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e?.target?.value)}
          className="col-span-1 md:col-span-2"
        />
        <Select
          placeholder="Filter by country"
          options={countryOptions}
          value={selectedCountry}
          onChange={setSelectedCountry}
        />
        <Select
          placeholder="Filter by status"
          options={statusOptions}
          value={selectedStatus}
          onChange={setSelectedStatus}
        />
      </div>
      {/* Bulk Actions */}
      {selectedCredits?.length > 0 && (
        <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <Icon name="CheckSquare" size={20} className="text-primary" />
              <span className="text-sm font-medium text-card-foreground">
                {selectedCredits?.length} credits selected
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <Button
                variant="outline"
                size="sm"
                iconName="FileCheck"
                iconPosition="left"
                onClick={handleBulkAuthorization}
              >
                Request Authorization
              </Button>
              <Button
                variant="outline"
                size="sm"
                iconName="RefreshCw"
                iconPosition="left"
                onClick={handleBulkCAUpdate}
              >
                Update CA Status
              </Button>
            </div>
          </div>
        </div>
      )}
      {/* Processing Statistics */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="CheckCircle" size={16} className="text-success" />
            <span className="text-xs font-medium text-muted-foreground">Authorized</span>
          </div>
          <div className="text-2xl font-bold text-card-foreground">2,847</div>
          <div className="text-xs text-success">+12% this month</div>
        </div>
        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Clock" size={16} className="text-warning" />
            <span className="text-xs font-medium text-muted-foreground">Pending</span>
          </div>
          <div className="text-2xl font-bold text-card-foreground">456</div>
          <div className="text-xs text-warning">Processing</div>
        </div>
        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="AlertTriangle" size={16} className="text-error" />
            <span className="text-xs font-medium text-muted-foreground">CA Required</span>
          </div>
          <div className="text-2xl font-bold text-card-foreground">89</div>
          <div className="text-xs text-error">Action needed</div>
        </div>
        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Shield" size={16} className="text-primary" />
            <span className="text-xs font-medium text-muted-foreground">NDC Aligned</span>
          </div>
          <div className="text-2xl font-bold text-card-foreground">98.2%</div>
          <div className="text-xs text-success">Compliance rate</div>
        </div>
      </div>
      {/* Quick Actions */}
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" size="sm" iconName="Download">
          Export Report
        </Button>
        <Button variant="outline" size="sm" iconName="Upload">
          Import Authorizations
        </Button>
        <Button variant="outline" size="sm" iconName="Settings">
          Configure Sync
        </Button>
        <Button variant="outline" size="sm" iconName="Bell">
          Set Alerts
        </Button>
      </div>
    </div>
  );
};

export default ITMOMetadataPanel;